import React from 'react';
import { useSelector } from 'react-redux';
import JsonDisplay from '../components/JsonDisplay';

const Output = () => {
  const { output } = useSelector((state) => state.global);
  return <JsonDisplay jsonData={output} />;
};

export default Output;
